import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import './index.scss'

const TariffsContent = observer(() => {
  const content = ContentState.tariffs?.info
  if (!content) return <></>
  return (
    <></>
    // <section className="tariffs-content">
    //   <div className="tariffs-content__img">
    //     <img src={content.img} />
    //   </div>
    //   <div className="tariffs-content__col">
    //     <div className="tariffs-content__title">{content.title}</div>
    //     <div
    //       className="tariffs-content__text"
    //       dangerouslySetInnerHTML={{ __html: content.text }}
    //     ></div>
    //     <a href={content.buttonLink} className="button black">
    //       {content.buttonTitle}
    //     </a>
    //   </div>
    // </section>
  )
})

export default TariffsContent
